import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { Department } from '@/types'

export interface AdminDepartmentsPayload {
  departments: Department[]
  total_sla_days: number
  total_urgent_sla_days: number
}

/**
 * GET /admin/departments behind the one ['admin-departments'] key. Every page
 * that lists sections reads it through here: the key used to hold a bare array
 * on some pages and the whole payload on others, so moving between them inside
 * staleTime handed a page the other shape and crashed it.
 */
export function useAdminDepartments() {
  return useQuery({
    queryKey: ['admin-departments'],
    queryFn: async () => (await api.get<AdminDepartmentsPayload>('/admin/departments')).data,
  })
}
